var map = {
	"./album.svg": 130,
	"./anchor.svg": 131,
	"./android-block.svg": 132,
	"./android-small.svg": 133,
	"./android.svg": 134,
	"./angle-down.svg": 135,
	"./angle-left.svg": 136,
	"./angle-right.svg": 137,
	"./angle-up.svg": 138,
	"./aquarius.svg": 139,
	"./aries.svg": 140,
	"./arrow-left.svg": 141,
	"./arrow-right.svg": 142,
	"./art-director.svg": 143,
	"./author.svg": 144,
	"./automobile.svg": 145,
	"./breaking-news.svg": 146,
	"./bullet-arrow.svg": 147,
	"./bundle.svg": 148,
	"./business.svg": 149,
	"./cancer.svg": 150,
	"./canvas.svg": 151,
	"./capricorn.svg": 152,
	"./cartoonist.svg": 153,
	"./cinema.svg": 154,
	"./clapboard.svg": 155,
	"./clipboard.svg": 156,
	"./close.svg": 157,
	"./comm-album.svg": 158,
	"./comm-automobile.svg": 159,
	"./comm-children.svg": 160,
	"./comm-cinema.svg": 161,
	"./comm-entertainment.svg": 162,
	"./comm-environment.svg": 163,
	"./comm-finance.svg": 164,
	"./comm-gadgets.svg": 165,
	"./comm-health.svg": 166,
	"./comm-lifestyle.svg": 167,
	"./comm-news.svg": 168,
	"./comm-science.svg": 169,
	"./comm-spiritual.svg": 170,
	"./comm-sports.svg": 171,
	"./comm-technology.svg": 172,
	"./comm-video.svg": 173,
	"./comm-vikatan-plus.svg": 174,
	"./comm-women.svg": 175,
	"./comm-world-cup.svg": 176,
	"./comment.svg": 177,
	"./creative-director.svg": 178,
	"./download.svg": 179,
	"./edited-by.svg": 180,
	"./email.svg": 181,
	"./environment.svg": 182,
	"./facebook-bg.svg": 183,
	"./facebook.svg": 184,
	"./filter-icon.svg": 185,
	"./filter.svg": 186,
	"./food-stylist.svg": 187,
	"./gallery.svg": 188,
	"./gemini.svg": 189,
	"./group.svg": 190,
	"./health.svg": 191,
	"./hexbackground.svg": 192,
	"./illustrator-t1.svg": 193,
	"./illustrator.svg": 194,
	"./infographer.svg": 195,
	"./instagram.svg": 196,
	"./ios-block.svg": 197,
	"./ios-small.svg": 198,
	"./ios.svg": 199,
	"./leo.svg": 200,
	"./libra.svg": 201,
	"./lifestyle.svg": 202,
	"./line-arrow-next.svg": 203,
	"./line-arrow-prev.svg": 204,
	"./linkedin.svg": 205,
	"./magazines.svg": 206,
	"./minus.svg": 207,
	"./mobile-share.svg": 208,
	"./news.svg": 209,
	"./pen.svg": 210,
	"./photo.svg": 211,
	"./photographer.svg": 212,
	"./photostory.svg": 213,
	"./pisces.svg": 214,
	"./plus.svg": 215,
	"./premium.svg": 216,
	"./producer.svg": 217,
	"./published-by.svg": 218,
	"./rss.svg": 219,
	"./sagitarius.svg": 220,
	"./scorpio.svg": 221,
	"./script-writer.svg": 222,
	"./search.svg": 223,
	"./share-alt.svg": 224,
	"./share.svg": 225,
	"./slider-next.svg": 226,
	"./slider-prev.svg": 227,
	"./sort.svg": 228,
	"./speaker.svg": 229,
	"./spiritual.svg": 230,
	"./sponsored.svg": 231,
	"./sports.svg": 232,
	"./stylist.svg": 233,
	"./taurus.svg": 234,
	"./technology.svg": 235,
	"./trending.svg": 236,
	"./twitter.svg": 237,
	"./user.svg": 238,
	"./video-editor.svg": 239,
	"./video.svg": 240,
	"./videographer.svg": 241,
	"./vikatan-tv.svg": 242,
	"./vikatantv.svg": 243,
	"./virgo.svg": 244,
	"./whatsapp.svg": 245,
	"./youtube.svg": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;